export default function PHP_chunk_split() {
  return (
    <div>
      <h1>PHP_chunk_split</h1>
    </div>
  );
}
